import { useEffect, useState } from 'react'
import StripeController from '../controllers/StripeController'
import { IErrorResponse } from '../types/ErrorResponse'
import { TStripeOnboardingStatus } from '../types/Stripe'

export const useInternationalSalesEnabled = () => {
  const [enabled, setEnabled] = useState(false)

  useEffect(() => {
    StripeController.getOnboardingStatus().then((result) => {
      const err = result as IErrorResponse
      if (!err.code) {
        const status = result as TStripeOnboardingStatus
        setEnabled(status.enabled && status.onboardingStatus === 'Completed')
      }
    })
  }, [])

  return enabled
}
